import React, { useEffect, useRef } from "react";

import Loader, { LoaderWrapper } from "../../../../../components/Loader";

import CreateMessage from "./CreateMessage";
import ChatMessage from "./ChatMessage";

import { Wrapper, Messages } from "./styles";
import { IProps } from "./interfaces";

const ChatChannel = ({ channel, getMessages, deleteChannel, sendMessage, users }: IProps) => {
    const messagesScroll = useRef<HTMLDivElement>(null);
    useEffect(() => {
        getMessages(channel);
        scrollToBottom();
    }, []);
    useEffect(() => {
        scrollToBottom();
    }, [channel.messages]);
    const scrollToBottom = () => {
        messagesScroll.current.scrollTo(0, 1000000);
    }
    return (
        <Wrapper>
            <Messages ref={messagesScroll}>
                {!channel.messages && (
                    <LoaderWrapper>
                        <Loader margin="70px" />
                    </LoaderWrapper>
                )}
                {channel.messages &&
                    channel.messages.map(message => (
                        <ChatMessage key={message._id} message={message} users={users} />
                    ))}
            </Messages>
            <CreateMessage
                channel={channel}
                deleteChannel={() => deleteChannel(channel)}
                sendMessage={message => sendMessage(channel, message)}
            />
        </Wrapper>
    );
}

export default ChatChannel;
